module.exports = __webpack_public_path__ + "static/media/scorbit-vision-8up-scoreboard.c4279211.png";